module.exports = __webpack_public_path__ + "static/jabme-3d568b65c9ddd3ea35a5c8d79427209c.png";